<div class="newsContainer" *ngIf="currentNews">
    <div class="leftContent">
        <div class="channelNameNews scroll-animation" [@enterUpFast]="animationStateIn"
            [@leaveDownFast]="animationStateOut">
            <p [innerHTML]="currentNews.channel"></p>
        </div>
        <div class="titleNews scroll-animation" [@enterUpFast]="animationStateIn" [@leaveDownFast]="animationStateOut">
            <h1 [innerHTML]="currentNews.title"></h1>
        </div>
        <div class="infoPublication scroll-animation" [@enterUpSlow]="animationStateIn"
            [@leaveDownSlow]="animationStateOut" (@leaveDownSlow.done)="animOutDone()"
            (@enterUpSlow.done)="animInDone()">
            <p *ngIf="currentNews.authorName && currentNews.date">{{currentNews.authorName}} <span class="dot"></span>
                {{ currentNews.date |
                datetimeFormat:'iso':currentLanguage}}</p>
            <p *ngIf="currentNews.authorName && !currentNews.date">{{currentNews.authorName}}</p>
            <p *ngIf="!currentNews.authorName && currentNews.date">{{ currentNews.date | datetimeFormat:'iso':currentLanguage}}</p>
        </div>
        <div class="descriptionNews scroll-animation" [@enterUpSlow]="animationStateIn"
            [@leaveDownSlow]="animationStateOut">
            <p [innerHTML]="!currentNews.summary ? !currentNews.content ? currentNews.description : currentNews.content : currentNews.summary">
            </p>
        </div>
    </div>
   <div class="rightContent rightContentWithoutVideo" *ngIf="currentNews.image && currentNews.videoUrl === null" [@fadeZoom]="animationStateOut ? 'out':'in'">
        <img *ngIf="currentNews.image !== null && currentNews.image.length === 1"
            [src]="currentNews.image[0]" alt="">

        <div class="multiImage"  *ngIf="currentNews.image.length > 1">
            <div class="current" [@fadeInOut]="animationImageStateOut? 'out':'in'">
                <img alt="" src="{{ currentImage }}"  class="current-image">
            </div>
            <div class="next" [@fadeOutIn]="animationImageStateOut? 'in':'out'">
                <img alt="" src="{{ nextImage }}"  class="next-image">
            </div>
        </div> 

        <div class="defaultImage" *ngIf="!currentNews.image?.length">
            <img src="../../../assets/logo/logo_default_news.svg" alt="">
        </div>
    </div>
 

    <div class="rightContent" *ngIf="currentNews.videoUrl !== null"
     [@fadeZoom]="animationStateOut ? 'out':'in'" 
     [style.background-image]="currentNews.image.length ? 'url(' + currentNews.image[0] + ')' : 'none'"
     [@zoomSmallFull]="animationVideoStateFull ? 'full':'small'" (@zoomSmallFull.done)="animMoveDone()">

     <div class="play-icon" [style.visibility]="displayVideo ? 'hidden' : 'visible'">
        <svg width="128" height="128" viewBox="0 0 128 128" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="64" cy="64" r="64" fill="#1E1E1E" fill-opacity="0.75"/>
            <path d="M93 64.4138L47 92V64V36L93 64.4138Z" fill="white"/>
            </svg>            
      </div>
     
        <video [style.visibility]="displayVideo ? 'visible' : 'hidden'" *ngIf="sharedService.isStreamVideo(currentNews) && currentNews.videoUrl !== null" tabindex="0" class="videoPlayer"
          muted="true" id="videoHTML" preload="metadata">
        </video> 

        <app-videoplayer [style.visibility]="displayVideo ? 'visible' : 'hidden'"  *ngIf="displayVideo && sharedService.isYoutubeVideo(currentNews) && sharedService.isScriptLoaded() && currentNews.videoUrl !== null"
            class="videoPlayer" (finished)="youtubeClose($event)" [currentNews]="currentNews"></app-videoplayer>

        <app-qr-code-video [style.visibility]="displayVideo ? 'visible' : 'hidden'" #qrCodeVideo class="qrCodeVideo"></app-qr-code-video>

    </div>
</div>